import React from "react";
import { Route, Routes } from "react-router";
import OrdersPage from "./OrdersPage";
import OrderDetailPage from "./OrderDetailPage";

const OrdersShell: React.FC = (): React.ReactElement => {
  return (
    <Routes>
      <Route path="/:orderId" element={<OrderDetailPage />} />
      <Route index element={<OrdersPage />} />
    </Routes>
  );
};

export default OrdersShell;
